import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActionsSubject, Store } from '@ngrx/store';
import { LoggedUser, PtUiAppRoutes } from '@pt/pt-models';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import {
  LocalStorageService,
  PtCoreActions,
  PtCoreSelectors,
} from '@pt/pt-core';
import { ofType } from '@ngrx/effects';

@Component({
  selector: 'pt-loading',
  template: `
    <div class="loader-container">
      <pt-loading-page></pt-loading-page>
    </div>
  `,
  styles: [
    `
      .loader-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100vh;
      }
    `,
  ],
})
export class LoadingComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  public loginResponse$ = this.store.select(PtCoreSelectors.loginResponse);
  public loggedUserId?: number;

  constructor(
    private store: Store,
    private localStorageService: LocalStorageService,
    private actionsSubject: ActionsSubject
  ) {
  }

  ngOnInit(): void {
    this.loginResponse$
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((loginResponse: LoggedUser) => {
        this.loggedUserId = loginResponse?.id;
    });

    this.store.dispatch(PtCoreActions.getOrganization());

    this.actionsSubject
      .pipe(
        ofType(PtCoreActions.getOrganizationSuccess),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        const loading = setTimeout(() => {
          const url = this.localStorageService.getLatestPage();
          if (url && this.loggedUserId) {
            if (url.endsWith('mfa')) {
              this.store.dispatch(
                PtCoreActions.navigateTo({ route: [PtUiAppRoutes.HOME] })
              );
            } else {
              window.open(url, '_self');
            }

          } else {
            this.store.dispatch(
              PtCoreActions.navigateTo({ route: [PtUiAppRoutes.HOME] })
            );
          }
          clearTimeout(loading);
        }, 1000);
      });

    this.actionsSubject
      .pipe(
        ofType(PtCoreActions.getOrganizationFailed),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        const loading = setTimeout(() => {
          this.store.dispatch(
            PtCoreActions.navigateTo({ route: [PtUiAppRoutes.FORBIDDEN] })
          );
          clearTimeout(loading);
        }, 1000);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
}
